import { Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
	selector: '[appValidateEmail][formControlName],[appValidateEmail][formControl],[appValidateEmail][ngModel]',
	providers: [
		{
			provide: NG_VALIDATORS,
			useExisting: forwardRef(() => EmailValidator),
			multi: true
		}
	]
})
export class EmailValidator implements Validator {
	validate(c: AbstractControl) {
		if (c.value == null || c.value.length === 0) {
			return null;
		} else {
			const EMAIL_REGEX = /.+@.+\..+/i;

			return EMAIL_REGEX.test(c.value) ? null : {
				invalidEmail: true
			};
		}
	}
}
